import { Card } from '@pmi/dsm-react';
import AlertForm from './AlertForm';
import ActiveAlertsList from './ActiveAlertsList';

export default function CustomAlertCard() {
  return (
    <Card className="p-0">
      <div className="p-4">
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <h4 className="fw-bold mb-0">Custom Alert</h4>
            <p className="mb-0">
              Create a custom alert notification that can be shared across all
              accounts or one specific account.
            </p>
          </div>

          <div className="my-4">
            <AlertForm />
          </div>

          <hr />

          <div className="mt-4">
            <ActiveAlertsList />
          </div>
        </div>
      </div>
    </Card>
  );
}
